import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbPortaHub } from 'app/abstract/full-pages/hub/porta-hub.abstract';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PortaHubService extends AbPortaHub {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigSeguranca(): Observable<any> {
    return this.get(`configseguranca/1`);
  }

  public saveConfigSeguranca(configSeguranca: any): Observable<any> {
    return this.save(`configseguranca/`, configSeguranca);
  }
}
